import React, { useEffect, useState } from 'react'
import {user} from "../join/join"
import socketIo from "socket.io-client"
import "./chat.css"
import {BiSend} from "react-icons/bi"
import {GrClose} from "react-icons/gr"
import Message from "../Message/Message"
const ENDPOINTS = "https://chatappdemome.herokuapp.com/"
let socket;

const Chat = () => {
    const [id,setid] = useState("")
    const [messages,setmessages] = useState([])

    const send=()=>{
    const message=document.getElementById('chatinput').value
        socket.emit("message",{message,id})
        document.getElementById('chatinput').value=""
 }


    

   
useEffect(()=>{
     socket = socketIo(ENDPOINTS,{transports:['websocket']})
    
    





    socket.on('connect',()=>{
        alert("connected")
        setid(socket.id) 
    })
    console.log(socket)
    socket.emit("joined",{user})
    
    socket.on("welcome",(data)=>{
        setmessages([...messages,data])
            console.log(data.user ,data.message)
    })
    socket.on("userJoined",(data)=>{
        setmessages([...messages,data])
               console.log(data.user,data.message)
    })
    socket.on("leave",(data)=>{
        setmessages([...messages,data])
        console.log(data.user,data.message)
    })

    return ()=>{
      socket.emit("disconnected")

      socket.off()
    }
},[])

useEffect(()=>{
socket.on("sendMessage",(data)=>{
    setmessages([...messages,data])
    console.log(data.user,data.message,data.id)
})
return ()=>{
    socket.off()
}
    


},[messages])


  return (
    <div className='chatpage'>
        <div className='chatContainer'>
            <div className='chatHeader'>
                <h2>C-Chat</h2>
                <a href='/'><GrClose  className='closeicon'/></a>
                
                 </div>
            <div className='chatBox'>
                {messages.map((e,i)=>(
                    <Message message={e.message} classs={e.id===id?"right":"left"} user={e.id===id?"":e.user} />
                ))}
               
               
            </div>
            <div className='inputBox'>
             <input type="text" id="chatinput" onKeyPress ={(e)=>e.key==="Enter"?send():null}></input>
             <button className='sendbtn' onClick={send}><BiSend /></button>
             </div>
        </div>
    
    </div>
  )
}

export default Chat
